import { DrEntity } from './dr-entity';

export class ProfileHistory extends DrEntity {
    comments: string;
    corpusHandle: string;
    modifiedBy: string;
    modifiedOn: string;
    profileHandle: string;

    constructor(value?: Partial<ProfileHistory>) {
        super(value);
        if (value) {
            Object.assign(this, value);
        }
    }
}
